import type { DataTableColumn } from '@/components/custom/erp/data-table-v2';
import { SearchColumnDef } from '@/components/custom/erp';

export const getDataTableColumns = (): DataTableColumn[] => [
  {
    field: 'invoiceNumber',
    headerName: 'Số c/từ nội bộ',
    width: 120
  },
  {
    field: 'invoiceDate',
    headerName: 'Ngày c/từ gốc',
    width: 120
  },
  {
    field: 'documentName',
    headerName: 'Số c/từ HĐĐT',
    width: 120
  },
  {
    field: 'adjustmentDate',
    headerName: 'Ngày điều chỉnh',
    width: 120
  },
  {
    field: 'customerCode',
    headerName: 'Mã khách hàng',
    width: 120
  },
  {
    field: 'status',
    headerName: 'Trạng thái HĐĐC',
    width: 160
  },
  {
    field: 'unitName',
    headerName: 'Tên đơn vị',
    width: 240
  },
  {
    field: 'customerName',
    headerName: 'Họ tên người mua hàng',
    width: 160
  },
  {
    field: 'taxCode',
    headerName: 'Mã số thuế',
    width: 160
  },
  {
    field: 'address',
    headerName: 'Địa chỉ',
    width: 240
  },
  {
    field: 'phoneNumber',
    headerName: 'Điện thoại',
    width: 160
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 160
  },
  {
    field: 'bankAccount',
    headerName: 'Tài khoản ngân hàng',
    width: 160
  },
  {
    field: 'bankName',
    headerName: 'Tên ngân hàng',
    width: 160
  },
  {
    field: 'paymentMethod',
    headerName: 'Ph/thức thanh toán',
    width: 160
  },
  {
    field: 'content',
    headerName: 'Nội dung',
    width: 240
  },
  {
    field: 'agreementDocument',
    headerName: 'Văn bản thỏa thuận',
    width: 240
  },
  {
    field: 'agreementDate',
    headerName: 'Ngày thỏa thuận',
    width: 160
  },
  {
    field: 'foreignCurrency',
    headerName: 'Ngoại tệ',
    width: 120
  },
  { field: 'totalMoney', headerName: 'Tổng tiền', width: 160 }
];
export const getInputTableColumns = (): DataTableColumn[] => [
  {
    field: 'column',
    headerName: 'Cột',
    width: 180
  },
  {
    field: 'columnName',
    headerName: 'Tên cột',
    width: 200
  },
  {
    field: 'columnNameEnglish',
    headerName: 'Tên tiếng anh',
    width: 200
  },
  {
    field: 'width',
    headerName: 'Độ rộng',
    width: 200
  },
  {
    field: 'format',
    headerName: 'Định dạng',
    width: 200
  },
  {
    field: 'align',
    headerName: 'Căn chỉnh',
    width: 200
  },
  {
    field: 'bold',
    headerName: 'In đậm',
    width: 200
  },
  {
    field: 'italic',
    headerName: 'Nghiêng',
    width: 200
  },
  {
    field: 'total',
    headerName: 'Tổng',
    width: 200
  }
];
